"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationContext = void 0;
const react_1 = require("react");
exports.NotificationContext = (0, react_1.createContext)(undefined);
//# sourceMappingURL=notification-context.js.map